function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1584",
  "data-name": "Path 1584",
  d: "M10.453,3.537V2.918a2.918,2.918,0,1,1,5.836,0v.618A10.584,10.584,0,0,1,23.93,13.691v2.1a15.924,15.924,0,0,0,.641,4.909,8.73,8.73,0,0,0,1.141,2.2,4.582,4.582,0,0,1,1.029,2.716c0,2.418-3.07,3.154-4.925,3.525a36.047,36.047,0,0,1-4.031.551l-.545,1a4.4,4.4,0,0,1-7.742,0l-.54-1a35.969,35.969,0,0,1-4.037-.551C3.07,28.777,0,28.041,0,25.623a4.582,4.582,0,0,1,1.029-2.716A8.73,8.73,0,0,0,2.17,20.7a15.92,15.92,0,0,0,.635-4.909v-2.1A10.588,10.588,0,0,1,10.453,3.537Zm2.918,28.052a2.984,2.984,0,0,1-2.631-1.569c1.068.045,2,.056,2.631.056s1.563-.011,2.631-.056A2.991,2.991,0,0,1,13.371,31.588Zm0-3.857c-6.432,0-11.234-1.113-11.234-2.109a2.688,2.688,0,0,1,.669-1.529c.849-1.271,2.137-3.194,2.137-8.3v-2.1a8.426,8.426,0,1,1,16.851,0v2.1c0,5.105,1.288,7.028,2.142,8.3a2.688,2.688,0,0,1,.669,1.529c0,1-4.807,2.109-11.234,2.109ZM14.878,3.036a11.116,11.116,0,0,0-1.507-.118,11.128,11.128,0,0,0-1.513.118V2.918a1.51,1.51,0,0,1,3.019,0Z",
  fill: "#f86542",
  fillRule: "evenodd"
});

var SvgIconNotif = function SvgIconNotif(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_x0020_1",
    width: 26.742,
    height: 33,
    viewBox: "0 0 26.742 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNotif, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-notif.5cb001d8.svg";
export { ForwardRef as ReactComponent };